export function addAddress(addressBookID, address) {
	return {
		type : "ADD_ADDRESS",
		addressBookID,
		address
	}
}

export function authChanged(user) {
	return {
		type : "AUTHENTICATION_CHANGED",
		user
	} 
}


// WEBPACK FOOTER //
// ./src/actions/actionCreators.js